<template>
  <div class="NavbarEmpresaSeleccionada">
    <div v-if="empresa.id && idUsuario" class="row fixed-top">
      <a href="javascript:void(0)" class="text-decoration-none btn-lg w-100">
        <p class="d-flex justify-content-center align-items-center">
          <small class="d-flex text-center">
            <b class="limit-text mt-1">
              <ion-icon class="me-0" name="business"></ion-icon>
              {{ empresa.sede }} - {{ empresa.nombre }}
            </b>
            <sup v-if="empresa.verificada">
              <i class="fas fa-check-circle ms-1 me-1"></i>
            </sup>
          </small>
        </p>
      </a>
    </div>
  </div>
</template>

<script>
import { db, auth } from '@/firebase';
import { doc, onSnapshot } from "firebase/firestore";
import { Modal } from 'bootstrap';
export default {
  name: "NavbarEmpresaSeleccionada",

  data() {
    return {
      idUsuario: "",
      empresa: {
        id: "",
        nombre: "",
        verificada: false,
        sede: "",
      },
      esSeleccionar: false,
    }
  },

  async created() {
    let usuario = auth.currentUser;
    if (usuario) {
      let usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
      if (usuarioDB) {
        this.idUsuario = usuarioDB.id;
        await this.obtenerUsuario();
      }
    }
  },

  methods: {
    async obtenerUsuario() {
      onSnapshot(doc(db, "usuarios", this.idUsuario), (usuario) => {
        if (usuario.data().preferencias.idEmpresaSeleccionada) {
          onSnapshot(doc(db, "empresas", usuario.data().preferencias.idEmpresaSeleccionada), (empresa) => {
            if (empresa.data().registro.estado != "Eliminado") {
              this.empresa = {
                id: empresa.id,
                nombre: empresa.data().razonSocial,
                verificada: empresa.data().verificada,
                sede: empresa.data().nit.nombre
              };
            }
            else {
              this.esSeleccionar = true;
              this.empresa.nombre = empresa.data().razonSocial
              setTimeout(() => {
                new Modal(document.getElementById('SeleccionarEmpresa'), {
                  backdrop: "static"
                }).show();
              }, 25)
            }
            this.$emit("empresaSeleccionada", true)
          });
        }
        else {
          this.empresa = {
            id: "",
            nombre: "",
            verificada: false,
            sede: ""
          };
          this.$emit("empresaSeleccionada", false)
        }
      });
    },
  }
};
</script>

<style scoped>
.row {
  background-color: rgb(248, 249, 250);
}

.row a {
  color: #343434;
  pointer-events: none;
}

.fas.fa-check-circle {
  margin-top: 15px;
}

.limit-text {
  text-transform: none;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

[data-bs-theme="dark"] .row {
  background-color: rgb(33, 33, 33);
}

[data-bs-theme="dark"] .row a {
  color: #fff;
}
</style>